// SEO-optimized mock data for Phoenix Well Control Academy

export const companyInfo = {
  name: "Phoenix Well Control Academy",
  tagline: "Building Competence, Securing Wells",
  heroTitle: "Leading Well Control Training & Rig Safety Certification in India",
  heroSubtitle: "Premier oil and gas training institute offering specialized well control courses, drilling safety certification, and rig site safety training for non-drilling personnel across Gujarat and India.",
  email: "hello@phoenixwellcontrol.com",
  phone: "+91-7622952967",
  location: "Gujarat, India",
  address: "52, Saundarya Silver Complex, Opposite SFW Gym, Radhanpur Road, Mehsana 384002, Gujarat, India",
  logoUrl: "https://customer-assets.emergentagent.com/job_7155e01c-1eab-4348-b074-a5be59806eae/artifacts/s5let56m_PWCA%20-%20Logo%20%281%29.png"
};

export const courses = [
  {
    id: 1,
    title: "Well Control Basics for Non-Drilling Personnel - Oil & Gas Safety Training",
    duration: "1-2 days",
    price: "INR 15,000",
    priceRange: "INR 12,000 - 18,000",
    groupPrice: "INR 15,000 per group (1-15 candidates)",
    groupPriceRange: "INR 12,000 - 18,000 per group (1-15 candidates)",
    format: "Classroom + Virtual",
    certificate: "Well Control Awareness Certificate (valid for 2 years)",
    targetAudience: ["Mud loggers", "Wireline crew", "Mud engineers", "Service company reps", "Safety officers", "Trainees/Interns", "Catering/housekeeping staff"],
    description: "Comprehensive well control training course covering basic principles of drilling operations, kick detection, and emergency response procedures for non-drilling oil and gas professionals.",
    topics: [
      "Drilling rig operations overview & safety roles",
      "Pressure control fundamentals in oil wells", 
      "Early kick indicators & warning signs recognition",
      "Emergency response protocols during well control incidents",
      "Communication procedures for drilling safety operations"
    ]
  },
  {
    id: 2,
    title: "Rig Site Safety Orientation - Oil & Gas Industry Safety Training",
    duration: "Half-day",
    price: "INR 10,000",
    priceRange: "INR 8,000 - 12,000",
    groupPrice: "INR 10,000 per group (1-15 candidates)",
    groupPriceRange: "INR 8,000 - 12,000 per group (1-15 candidates)",
    format: "Classroom + Virtual",
    certificate: "Rig Site Access Safety Badge (valid for 1 year)",
    targetAudience: ["Third-party contractors", "Temporary personnel", "Visitors entering drilling zones"],
    description: "Essential rig safety training covering hazard identification, safety zones, emergency procedures, and PPE requirements for oil and gas drilling operations.",
    topics: [
      "Drilling rig layout and high-risk zone identification",
      "Personal protective equipment (PPE) standards for oil rigs",
      "Safety signage, alarms & emergency signals understanding",
      "Emergency evacuation drills and muster procedures",
      "Safety culture role of third-party personnel in drilling operations"
    ]
  },
  {
    id: 3,
    title: "Communication, Interface & Handover Protocols for Rigsite Support Teams",
    duration: "1/2 to 1 day",
    price: "INR 20,000",
    priceRange: "INR 18,000 - 25,000",
    groupPrice: "INR 20,000 per group (1-15 candidates)",
    groupPriceRange: "INR 18,000 - 25,000 per group (1-15 candidates)",
    format: "Classroom + Virtual",
    certificate: "Communication Protocols Certificate",
    targetAudience: ["Service company engineers", "HSE personnel", "New graduate trainees", "Maintenance, logistics, and operations support staff"],
    description: "Essential communication training focused on structured handover techniques, interface risk management, and effective communication protocols for non-drilling personnel working in high-risk rig environments.",
    topics: [
      "Introduction to rigsite communication challenges and importance",
      "Roles and interfaces between drilling and non-drilling teams",
      "Structured handover protocols and three-way communication model",
      "Communication tools: PTW, radios, electronic logs, and checklists",
      "Interface risk awareness for simultaneous operations (SIMOPS)",
      "Best practices with role-play exercises and case study analysis"
    ]
  },
  {
    id: 4,
    title: "Human Factors in Well Control - Safety Leadership Training",
    duration: "1 day", 
    price: "INR 18,000",
    priceRange: "INR 15,000 - 20,000",
    groupPrice: "INR 18,000 per group (1-15 candidates)",
    groupPriceRange: "INR 15,000 - 20,000 per group (1-15 candidates)",
    format: "Interactive workshops + Virtual",
    certificate: "Safety Leadership Certificate",
    targetAudience: ["All rig personnel", "Supervisors", "Safety managers"],
    description: "Critical safety training addressing human error prevention, team communication, and decision-making under pressure in oil and gas drilling operations.",
    topics: [
      "Situational awareness and hazard perception in drilling",
      "Decision fatigue & cognitive bias in high-pressure situations",
      "Crisis communication protocols for drilling emergencies",
      "Case studies: Human factors in well control incidents",
      "Team coordination during kick or blowout emergency scenarios"
    ]
  },
  {
    id: 5,
    title: "Hazard Identification & Barrier Management for Oil & Gas Operations",
    duration: "1 day",
    price: "INR 22,000",
    priceRange: "INR 20,000 - 25,000",
    groupPrice: "INR 22,000 per group (1-15 candidates)",
    groupPriceRange: "INR 20,000 - 25,000 per group (1-15 candidates)", 
    format: "Hands-on workshop + Virtual",
    certificate: "Hazard Assessment Certificate",
    targetAudience: ["Support staff", "Maintenance personnel", "Quality assurance teams"],
    description: "Advanced safety training teaching systematic hazard identification, risk assessment, and barrier management principles for oil and gas drilling operations.",
    topics: [
      "Bowtie risk analysis diagrams & barrier modeling for drilling",
      "Identifying degraded safety barriers in drilling operations",
      "Risk mitigation strategies for oil and gas facilities",
      "Stop work authority and safety intervention protocols"
    ]
  },
  {
    id: 6,
    title: "Blowout Preventer (BOP) Systems Training for Non-Certified Personnel",
    duration: "Half-day",
    price: "INR 12,000",
    priceRange: "INR 10,000 - 15,000",
    groupPrice: "INR 12,000 per group (1-15 candidates)",
    groupPriceRange: "INR 10,000 - 15,000 per group (1-15 candidates)",
    format: "Instructor-led + Online module",
    certificate: "BOP Awareness Certificate",
    targetAudience: ["All non-drilling rig personnel", "Maintenance staff", "Support contractors"],
    description: "Essential BOP system training covering equipment function, safety protocols, and operational procedures for drilling well control equipment.",
    topics: [
      "Blowout preventer function and well control importance",
      "BOP stack components and safety systems overview",
      "Emergency response role during kicks and blowouts", 
      "Safe distance protocols and interference prevention",
      "BOP maintenance safety and operational procedures"
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    position: "HSE Manager",
    company: "Leading Energy Corporation",
    content: "Phoenix Well Control Academy's drilling safety training transformed our team's hazard awareness. The comprehensive well control courses filled critical knowledge gaps we didn't realize existed in our oil and gas operations.",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Mitchell", 
    position: "Operations Supervisor",
    company: "Schlumberger India",
    content: "Outstanding MPD training program for our support teams. The instructors' expertise in well control systems and drilling safety procedures exceeded our expectations for oil field training.",
    rating: 5
  },
  {
    id: 3,
    name: "Amit Patel",
    position: "Safety Officer",
    company: "Reliance Industries",
    content: "Best-in-class rig safety training with practical scenarios. The human factors course should be mandatory for everyone working in oil and gas drilling operations across India.",
    rating: 5
  },
  {
    id: 4,
    name: "Dr. Priya Sharma",
    position: "Training Manager",
    company: "Major Energy Corporation",
    content: "Professional oil and gas training institute with comprehensive safety courses. Phoenix Academy's approach to well control education and barrier thinking has significantly improved our drilling safety culture.",
    rating: 5
  }
];

export const benefits = [
  "Reduces operational downtime due to untrained support staff in oil and gas operations",
  "Improves overall rig-site safety culture and drilling operation efficiency", 
  "Ensures compliance with oil and gas industry safety regulations and standards",
  "Helps meet regulatory and international petroleum industry training standards",
  "Enhances confidence and technical capability of all drilling personnel",
  "Strengthens well control awareness across entire oil rig workforce"
];

export const philosophyPoints = [
  {
    title: "Accessible Oil & Gas Training",
    description: "No prior drilling experience required - comprehensive safety training for all levels"
  },
  {
    title: "Real-World Drilling Scenarios", 
    description: "Rig-based simulations and actual oil field case studies from India and international operations"
  },
  {
    title: "Industry-Standard Curriculum",
    description: "Built around major wellcontrol training guidelines put forward by international petroleum bodies"
  },
  {
    title: "Safety-First Oil Field Focus",
    description: "Training rooted in proactive hazard recognition and emergency response for drilling operations"
  }
];